/**
 * A request the server answered with an error, and the status it answered
 * with. Every API client throws one (or its own subclass, or any error with a
 * numeric `status`), so the query client can tell the server's ANSWER from a
 * FAULT on the way to it (hooks/queryClient.ts). `status` is absent when
 * nothing answered: the network failed before the server could.
 */
export class HttpError extends Error {
  constructor(message: string, readonly status?: number) {
    super(message);
  }
}

/**
 * The status a failed request was answered with, or undefined when nothing
 * answered. Read from any error that carries a numeric `status`: ours, and
 * dicomweb-client's, whose 0 means the network failed.
 */
export function statusOf(err: unknown): number | undefined {
  const status = (err as { status?: unknown } | null | undefined)?.status;
  return typeof status === 'number' && status > 0 ? status : undefined;
}

/**
 * The server said no: a 4xx, which asking again only repeats. Not a 408 or a
 * 429, which say "not now" rather than "no".
 */
export function isRefusal(err: unknown): boolean {
  const status = statusOf(err);
  return status !== undefined && status >= 400 && status < 500 && status !== 408 && status !== 429;
}
